<!-- <div *ngIf="!newStyle" class="teaser-detail" [ngClass]="{'list': fromList}"
    [style.width.px]="responsiveTeaserSize?.width" [style.height.px]="responsiveTeaserSize?.height - 183">
    <a *ngIf="hovered" [routerLink]="['/play',video?.key]" [queryParams]="hasWatched ? {id:video?.lastID} : {}">
        <div class="detail-ctn">
        
            <div class="detail-tags" *ngIf="cidMapperArray(video?.cidMapper).length <= 1">
                <span>{{ video?.videoType || video?.cid }}</span>
                <span>{{ video?.regional }}</span>
                <span>{{ video?.year }}</span>
                <span style="margin-right: 0;">{{ video?.lang }}</span>
            </div>
            <div class="detail-tags"
                *ngIf="cidMapperArray(video?.cidMapper).length > 1 && cidMapperArray(video?.cidMapper).length < 4">
                <span>{{ cidMapperArray(video?.cidMapper)[0] }}</span>
                <span>{{ cidMapperArray(video?.cidMapper)[1] }}</span>
                <span>{{ cidMapperArray(video?.cidMapper).length > 2 ?
                    cidMapperArray(video?.cidMapper)[2] : video?.regional }}</span>
                <span style="margin-right: 0;">{{ cidMapperArray(video?.cidMapper).length > 2 ?
                    video?.regional : video?.year }}</span>
            </div>
            <div class="detail-tags" *ngIf="cidMapperArray(video?.cidMapper).length === 4">
                <span>{{ cidMapperArray(video?.cidMapper)[0] }}</span>
                <span>{{ cidMapperArray(video?.cidMapper)[1] }}</span>
                <span>{{ cidMapperArray(video?.cidMapper)[2] }}</span>
                <span style="margin-right: 0;">{{ cidMapperArray(video?.cidMapper)[3] }}</span>
            </div>
            <div class="detail-intro">
                <div class="detail-date" *ngIf="video?.isSerial || video?.inProgress">
                    <span class="intro-title">更新: </span>{{ video?.updateweekly ?
                    video?.updateweekly : '未知' }}
                </div>
                <div class="detail-date" *ngIf="!video?.isSerial && !video?.inProgress">
                    <span class="intro-title">添加: </span>{{ video.addTime || video.updated ?
                    video.addTime || video.updated : '未知' }}
                </div>
                <div class="detail-starring" [ngClass]="{'lower': !video?.starring}">
                    <span class="intro-title">主演: </span>{{ video?.starring ?
                    replaceComma(video?.starring) : '未知' }}
                </div>
                <div class="detail-story">
                    <span class="intro-title">简介: </span>
                    <span [innerHTML]="video?.contxt ? video?.contxt : '暂无介绍'"></span>
                </div>
            </div>
            <div class="detail-action" [style.width.px]="responsiveTeaserSize?.width - 20">
                <div class="d-flex align-items-center">
                    <i class="iconfont iconrenqi d-block mr-2" style="color: #fe6f71; top: auto; font-size: 21px;"></i>
                    <span class="mr-0 fs-16 hot-number">{{ video?.hot | chineseCounter }}</span>
                </div>
                <div class="d-flex align-items-center detail-dialog" *ngIf="!isAdult"
                    (click)="openTeaserDialog($event, video)">
                    详情
                </div>
            </div>
        </div>
    </a>
</div> -->

<div class="teaser-detail new" [ngClass]="{'list': fromList}"
    [style.width.px]="responsiveTeaserSize?.width" [style.height.px]="responsiveTeaserSize?.height - 183"
    [style.background-image]="'url(' + video.image + '?w=238&h=340&format=jpg&mode=stretch)'">
    <a *ngIf="hovered" [routerLink]="['/play',video?.key]" [queryParams]="hasWatched ? {id:video?.lastID} : {}">
        <div class="teaser-detail-cover">
            <div class="teaser-detail-cover-play-area">
                <div class="teaser-detail-cover-play-button" title="{{video?.title}}">
                    <i class="iconfont iconbofang teaser-detail-play-icon"></i>
                </div>
            </div>
        </div>
        <div class="recommended" *ngIf="video.recommended"></div>
        <div class="top-right-icon">
            <div class="high-res" *ngIf="video.vipResource === '4K' || video.vipResource === '2K'"
                [ngClass]="{'icon-4K': video.vipResource === '4K', 'icon-2K': video.vipResource === '2K'}">
            </div>
            <div class="updated" *ngIf="video.updates && video.updates > 0">{{ video.atypeName === '电影' ? '新' :
                video.updates }}</div>
        </div>
        <div class="detail-ctn new">
            <div class="detail-rating" *ngIf="!!video.score && video.score !== '暂无评分'">{{ video.score }}</div>
            <div class="detail-title">
                {{ video.title }}
            </div>
            <div class="detail-tags new" *ngIf="(video?.cidMapper|commaToArray).length <= 1">
                <span>{{ video?.videoType || video?.cid }}</span>
                <span>{{ video?.regional }}</span>
                <span>{{ video?.year }}</span>
                <span style="margin-right: 0;">{{ video?.lang }}</span>
            </div>
            <div class="detail-tags new"
                *ngIf="(video?.cidMapper|commaToArray).length > 1 && (video?.cidMapper|commaToArray).length < 4">
                <span>{{ (video?.cidMapper|commaToArray)[0] }}</span>
                <span>{{ (video?.cidMapper|commaToArray)[1] }}</span>
                <span>{{ (video?.cidMapper|commaToArray).length > 2 ?
                    (video?.cidMapper|commaToArray)[2] : video?.regional }}</span>
                <span style="margin-right: 0;">{{ (video?.cidMapper|commaToArray).length > 2 ?
                    video?.regional : video?.year }}</span>
            </div>
            <div class="detail-tags new" *ngIf="(video?.cidMapper|commaToArray).length === 4">
                <span>{{ (video?.cidMapper|commaToArray)[0] }}</span>
                <span>{{ (video?.cidMapper|commaToArray)[1] }}</span>
                <span>{{ (video?.cidMapper|commaToArray)[2] }}</span>
                <span style="margin-right: 0;">{{ (video?.cidMapper|commaToArray)[3] }}</span>
            </div>
            <div class="detail-intro new">
                <div class="detail-date" *ngIf="video?.isSerial || video?.inProgress">
                    <span class="intro-title new">更新: </span>{{ video?.updateweekly ?
                    video?.updateweekly : '未知' }}
                </div>
                <div class="detail-date" *ngIf="!video?.isSerial && !video?.inProgress">
                    <span class="intro-title new">添加: </span>{{ video.addTime || video.updated ?
                    video.addTime || video.updated : '未知' }}
                </div>
                <div class="detail-starring" [ngClass]="{'lower': !video?.starring}">
                    <span class="intro-title new">主演: </span>{{ video?.starring ?
                        (video?.starring|commaToString) : '未知' }}
                </div>
                <div class="detail-story">
                    <span class="intro-title new">简介: </span>
                    <span [innerHTML]="video?.contxt ? video?.contxt : '暂无介绍'"></span>
                </div>
            </div>
            <div class="detail-action new" [style.width.px]="responsiveTeaserSize?.width - 20">
                <div class="d-flex align-items-center">
                    <i class="iconfont iconhot d-block mr-1" style="color: #ff743d; top: auto; font-size: 21px;"></i>
                    <span class="mr-0 fs-12 hot-number new">{{ video?.hot | chineseCounter }}</span>
                </div>
                <div class="d-flex align-items-center detail-dialog new" *ngIf="!isAdult"
                    (click)="openTeaserDialog($event, video)">
                    详情
                </div>
            </div>
        </div>
    </a>
</div>